var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"loader"},[_c('div',{style:({ background: _vm.color })}),_c('div',{style:({ background: _vm.color })}),_c('div',{style:({ background: _vm.color })})])])}
var staticRenderFns = []

export { render, staticRenderFns }